import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { fromEvent, interval } from 'rxjs';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { PcoModel } from 'src/app/shared/models/abre-cuentas.model';
import { Changes, TagEvent, TagPath } from 'src/app/shared/models/dali-tags.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import {
  ChannelCommunicatorService,
} from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-success-pco',
  templateUrl: './success-pco.component.html',
  styleUrls: ['./success-pco.component.scss'],
})
export class SuccessPcoComponent implements OnInit {

  aliances;
  amountPco: PcoModel;
  amountAproved: string;
  userId: DocumentModel;
  tagErrorName: TagPath;
  name: string;
  copyProperty = 'success_pco';
  isGrayZone = false;
  tittleClass = 'title';
  sbIteration: any;
  codBizagi: any;
  postLogin: any;
  productSelected: any;
  aproved = true;
  show = false;
  changeamount: string;
  flag = false;
  formGroup: FormGroup;

  channelId;
  /**
   * Creates an instance of SuccessPcoComponent.
   * @param {AbreCuentasNavigationService} abreCuentasNavigationService
   * @param {AbreCuentasService} abreCuentasService
   * @memberof SuccessPcoComponent
   */

  constructor(
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private _sanitizer: DomSanitizer,
    private parameterService: ParametersService,
    private channelCommunicatorService: ChannelCommunicatorService,
    public copyService: CopyService,
    private taggingService: TaggingService,
    private bitacoraService: BitacoraService,
    private biocatchService: BioCatchService,
    private adjustEvent: AdjustEvent,
  ) {
    this.headerService.show(false, true, true);
  }

  ngOnInit() {
    // this.channelId = this.channelCommunicatorService.getChannelId()
    this.productSelected = this.abreCuentasService.getproductSelected();
    if (this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
      const event = {
        eventToken: '2pkhe5',
        callbackParams: callbackAdjustContratarTC,
      };
      this.adjustEvent.adjustTrackEvent(event);
    }
    const isEvidente = this.biocatchService.isEvidenteCase();
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    this.biocatchService.changeContext(StepBiocatchEnum.oferta, product, false, isEvidente);
    this.aliances = this.parameterService.getSetting(OpEnum.ALLIANCES_TC);
    this.userId = this.abreCuentasService.getDocumentInfo();
    this.amountPco = this.abreCuentasService.getPcoModel();
    this.formGroup = new FormGroup({
      quotaValueInput: new FormControl({ value: '', formState: '' }),
    });
    this.getPcoStatus();
    this.codBizagi = this.abreCuentasService.getSolicitationId();
    const postLogin = this.abreCuentasService.getPostlogin();
    console.log('postLogin', postLogin);
    console.log('productSelected', this.productSelected);

    if (postLogin === true && this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
      console.log('isGrayZone', this.isGrayZone);

      this.navigationService.getCurrentStep().tag_name = this.isGrayZone ? 'pv437' : 'pv435';
    }
  }

  next() {
    if (!this.isGrayZone) {
      const inputChange = this.formGroup.controls['quotaValueInput'].value;
      this.abreCuentasService.setAmountPcoAproved(inputChange);
      const bitacoraEvent = `modify_${inputChange}`;
      this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    }
    this.tagPageEvent('1');
    this.abreCuentasService.caseInfoError('121');
    this.navigationService.nextStep();
  }

  setDocumentEvent(iteration: any) {
    let elDocuments = document.getElementById('documents-container') as HTMLElement;
    elDocuments = elDocuments.getElementsByTagName('a')[0];
    if (elDocuments) {
      const source = fromEvent(elDocuments, 'click');
      source.subscribe(() => { this.showRequiredDocuments(); });
      this.sbIteration.unsubscribe();
    } else if (iteration > 20) {
      this.sbIteration.unsubscribe();
    }
  }

  /**
   * Summary users reject process continue
   *
   * @memberof SuccessPcoComponent
   */
  exit() {
    this.tagPageEvent('2');
    this.bitacoraService.saveDataInBitacora('mejor_otro_dia_pco');
    this.navigationService.loadExitScreen = true;
  }

  /**
   * get Pco status code
   *
   * @memberof ProductDetailComponent
   */
  getPcoStatus() {
    if (this.amountPco.solicitation_status.status_code === 'PCO03') {
      const iteration = interval(300);
      this.sbIteration = iteration.subscribe(iter => { this.setDocumentEvent(iter); });
      this.isGrayZone = true;
      this.tittleClass = 'gz-tittle';
      this.copyProperty = 'gray_zone_pco';
      this.postLogin = this.abreCuentasService.getPostlogin();
      if (!this.postLogin === false && this.isGrayZone === true &&
        this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
        const event = {
          eventToken: 'f2i57r',
          callbackParams: callbackAdjustContratarTC,
        };
        this.adjustEvent.adjustTrackEvent(event);
      }
      return;
    }
    console.log('amountPco', this.amountPco);

    this.amountAproved = this.amountPco.granted_product.limit_amount.amount
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    this.formGroup.controls['quotaValueInput'].setValue(this.amountPco.granted_product.limit_amount.amount);
  }
  selectActiveBtns() {
    this.show = !this.show;
    this.validate();
  }
  validate() {
    let valor = this.formGroup.controls['quotaValueInput'].value;
    console.log('Valor cambiado: ', valor);
    if (+valor >= 1000000 && +valor <= parseInt(this.amountAproved.replace(/\./g, ''), 10)) {
      console.log(valor);
      this.abreCuentasService.setvalidate(+valor);
      this.aproved = true;
    } else {
      this.aproved = false;
    }

  }

  showRequiredDocuments() {
    this.navigationService.nextStep('202');
  }

  /**
   * Sanitize text when html from product details
   *
   * @param {string} text
   * @returns
   * @memberof ProductDetailComponent
   */
  sanitize(text: string) {
    return this._sanitizer.sanitize(SecurityContext.HTML, text);
  }

  tagPageEvent(eventNumber: string) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].path,
          value: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].value,
        },
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].path,
          value: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.button,
          position: EVENT.customCategory.position.bottom,
        },
        action: EVENT.customAction.click,
        label: EVENT[`${tagPageName}E${eventNumber}customLabel`] ? EVENT[`${tagPageName}E${eventNumber}customLabel`] : '',
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Opens link to itau page
   *
   * @memberof SuccessPcoComponent
   */
  openLink() {
    this.channelCommunicatorService.getImpl().openExternalBrowser(
      this.copyService.copies[this.copyProperty].body_link, 5, true);
  }

}
